export default {
  welcome: {
    your_language: '您的语言',
    language_to_learn: '您想学习的语言',
    start_learning: '开始学习',
    how_does_this_work: '这是如何工作的？',
    welcome_1: '欢迎来到 JAALUU',
    welcome_2: '在这里您可以学习语言',
    welcome_3: '阅读带字幕的文本或观看视频',
    welcome_4: '点击单词查看翻译、例句和定义',
    main_teaser: '提高您的语言技能 - 轻松且免费',
    hero_headline: '别再死记硬背单词表了，用 AI 沉浸式学习，说得流利自信',
    hero_subheadline:
      'Jaaluu 通过真实内容、个性化聊天机器人对话和间隔重复系统，帮助您每天只需几分钟就能掌握一门新语言。',
    hero_cta: '免费开始学习',
    select_language_and_start: '选择语言并开始',
    how_to_title: '阅读文本、书籍、新闻或观看视频',
    how_to_text: '您可以从各种文本、书籍、新闻或视频中进行选择',
    click_on_word_title: '自动翻译、例句和定义',
    click_on_word_text:
      '点击任何单词即可获得自动翻译、例句和定义。您还可以自动翻译整个句子，或将单词与图片链接并创建词汇网络。',
    listen_title: '听单词和文本',
    listen_text: '您可以听任何单词、句子或整篇文本并练习发音',
    conversations_title: '练习对话',
    conversations_text:
      '您可以通过与虚拟聊天机器人交谈来练习对话。您需要完成以下任务：`在餐厅订餐`或`问路`。',
    writing_title: '拼写',
    writing_text_1: '通过写作练习拼写',
    writing_text_2: '您的文本将被检查拼写错误、内容和语法。',
    texts_and_videos_title: '找到您的水平',
    texts_and_videos_text:
      '您可以在简单的短语和儿童文本、新闻、维基百科文章或书籍之间进行选择，选择最适合您的',
    srs_title: '重复和训练词汇',
    srs_text_1: '您可以将任何单词或整个句子保存为收藏夹以便稍后重复',
    srs_text_2: '使用抽认卡和简单练习训练您的词汇，并跟踪您的进度',
    srs_text_3: 'SRS重复系统通过在正确的时间重复单词来帮助您更有效地学习',
    own_text_title: '专业词汇',
    own_text_text:
      '您可以创建关于特定主题的文本以学习专业词汇。您还可以创建包含您想学习的单词的文本。',
    wordmap_title: '词汇网络',
    wordmap_text_1: '您可以创建词汇网络并用简单的句子连接单词',
    wordmap_text_2: '单词卡可以保存为收藏夹，便于重复和训练',
    sayings_title: '习语',
    sayings_text: '在这里您会找到常用短语和习语，并按类别分类。您可以跟踪进度并继续有条理地发展。',
    details: '详情',
    details_text_and_videos_title: '发现 Jaaluu - 您快速有效学习语言的钥匙！',
    details_text_and_videos_text:
      'Jaaluu 为您提供丰富的文本和视频以提高您的语言水平。如果您已经能够理解简单的单词和句子，该平台非常理想。对于初学者，有简单的短语和习语、儿童文本、词典和视频，便于轻松入门。对于高级学习者，有新闻、维基百科文章、书籍和令人兴奋的视频，以便更深入地理解，或交互式聊天机器人对话。此外，您可以训练拼写并获得改善拼写错误、内容和语法的提示。',
    details_click_on_words_title: '轻松学习词汇：快速、互动且持久！',
    details_click_on_words_text:
      '学习词汇可能很乏味，因为查找单词和定义需要大量时间。Jaaluu 解决了这个问题：只需点击一个单词即可立即获得翻译、例句、定义和解释。这节省了时间，帮助您更快、更有效地学习！',
    details_listen_title: '听和练习：听单词、句子和文本以提高您的语言技能！',
    details_listen_text:
      '您可以听到一切 - 任何单词、任何句子，甚至整篇文本。只需播放和收听！此功能可帮助您练习正确的发音并提高听力理解能力。您还可以听对话并培养自然交流的感觉。非常适合内化词汇并在日常情况下加强您的语言技能。',
    details_conversations_title: '实用语言训练：日常生活的真实对话！',
    details_conversations_text:
      '使用 Jaaluu，您可以与聊天机器人练习真实对话，并为典型的日常情况做好准备。例如，您可以在餐厅订餐并付账，或问路。或者，您可以在新工作的第一天与新同事聊天。您的句子将被自动分析，为您提供直接反馈并提高您的语言技能。这样，您就能为真实对话进行实用且有效的训练！',
    details_writing_title: '日常生活的写作练习：通过实际任务提高您的技能！',
    details_writing_text:
      '您可以通过掌握小型真实任务（例如写申请或投诉信）来练习写作。然后，您的文本将被自动分析，您将收到有关拼写、内容和语法的直接反馈。这样，您就能提高写作技能，并为日常生活做好充分准备！',
    details_srs_title: '使用 SRS 有效学习词汇：自动重复和个性化进度分析！',
    details_srs_text:
      '使用 SRS 系统（间隔重复系统），您可以有效地学习和重复词汇。该系统会提醒您何时重复单词，以便长期记住它们。SRS 基于科学方法，即在特定间隔内重复可以增强记忆。您还将收到每个单词的学习进度和成功率统计数据，因此您可以专注于自己的弱点，并始终知道自己在词汇学习方面的进展情况。',
    details_own_text_title: '个性化学习：创建自定义文本以进行针对性的词汇和主题练习！',
    details_own_text_text:
      '使用 Jaaluu，您可以轻松创建自己想要关注的领域的文本。描述您想学习的领域或词汇，您将获得一篇要阅读和练习的文本。这样，您就可以专注于特定的主题或词汇，并扩展对您重要的领域的知识。这种量身定制的方法可以帮助您更有效、更精确地学习！此外，您可以创建包含您想复习的所有词汇的文本。这使您可以在上下文中学习和复习词汇，从而更容易记住。',
    details_wordmap_title: '单词卡：连接您的知识并轻松记住单词！',
    details_wordmap_text:
      '您可以创建单词卡，帮助您建立单词网络并更有效地记住它们。以交互方式向单词卡添加单词和句子，并逐步扩展您的词汇量。这会在您的大脑中创建和加强连接，并以有趣的方式建立联想。这样，您就能提高语言理解能力 - 持久！',
    details_paste_text_title: '使用您自己的文本：粘贴您的内容以专注学习！',
    details_paste_text_text:
      '使用 Jaaluu，您还可以粘贴自己的文本用于练习。这使您可以使用自己的材料并在现实生活中训练词汇。',
    explore_more: '探索更多 Jaaluu 功能',
    site_also_available: '该网站也可用于',
    which_languages_title: '我可以学习哪些语言？',
    which_languages_text:
      '在这里您可以学习西班牙语、法语、意大利语、德语、葡萄牙语、俄语和波兰语。只需选择您想学习的语言，您就可以开始了！'
  },
  intro: {
    your_level: '您的语言水平是什么？',
    beginner_explained: '您可以阅读简单的句子',
    intermediate_explained: '您可以阅读简单的文本和文章',
    advanced_explained: '您可以阅读更复杂的文本',
    your_cefr_level: '您的 CEFR 级别是',
    lets_start: '让我们从什么开始？',
    intermediate_options: {
      simple_texts: '阅读文本',
      simple_articles: '阅读文章',
      sayings: '学习谚语',
      simple_phrases: '阅读典型句子',
      klexikon: '阅读 Klexikon（儿童百科全书）'
    },
    advanced_options: {
      news: '阅读新闻',
      wikipedia: '阅读文章',
      books: '阅读书籍',
      conversations: '练习对话',
      writing: '练习写作'
    }
  },
  languages: {
    de: '德语',
    en: '英语',
    es: '西班牙语',
    fr: '法语',
    it: '意大利语',
    pt: '葡萄牙语',
    ru: '俄语',
    zh: '中文',
    pl: '波兰语'
  },
  general: {
    close: '关闭',
    home: '首页',
    beginner: '初学者',
    intermediate: '中级',
    advanced: '高级',
    search: '搜索',
    what_to_read: '你想读什么？',
    search_imperative: '搜索',
    translate: '翻译',
    what_you_want_to_translate: '您想把什么从{from}翻译成{to}？',
    word_not_found: '单词 "{word}" 似乎不存在。',
    similar_words_found: '我找到了最相似的词：',
    settings: '设置',
    vocabulary: '词汇',
    most_important_words: '{n} 个最重要的词',
    learn_most_important_words: '学习500个最重要的词',
    continue_with_word: '继续学第{n}个词',
    jokes: '笑话',
    n_jokes: '{n} 个笑话',
    learn_jokes: '学习200个笑话',
    continue_with_joke: '继续第{n}个笑话',
    shorts: '短文本',
    articles: '文章',
    feeds: '新闻',
    videos: '视频',
    read: '阅读',
    view: '查看',
    listen: '听',
    save: '保存',
    more: '更多',
    back: '返回',
    next: '下一个',
    continue_with_sentence: '继续第 {sentenceIdx} 句',
    easy: '简单',
    medium: '中等',
    hard: '困难',
    all: '全部',
    level: '级别',
    font_size: '字体大小',
    language: '语言',
    send: '发送',
    image: '图片',
    wordmap: '词汇地图',
    open: '打开',
    add: '添加',
    question: '问题',
    start: '开始',
    continue: '继续',
    words: '单词',
    points: '分',
    repeat: '重复',
    test: '测试',
    nothing_found: '未找到',
    skip: '跳过',
    congratulations: '祝贺',
    well_done: '做得好！',
    try_again: '再试一次',
    finish: '完成',
    total: '总计',
    synapsis_score: '突触分数',
    synapsis_milestone: '突触分数里程碑！新分数：{score}',
    fun_facts: '关于 {country} 的趣闻',
    fun_facts_missing_points: '距离下一个关于 {country} 的趣闻还需要的分数',
    fun_facts_previous: '以前的趣闻 ({count})',
    fun_fact_unlocked: '您现在可以查看关于 {country} 的新趣闻',
    finished_units: '单元',
    finished_course_chapters: '课程章节',
    grammar_chapters: '语法章节',
    completed: '已完成',
    turn: '翻转'
  },
  app_bar: {
    search_in_foreign_language: '以外语搜索',
    menu: '菜单'
  },
  category: {
    chapter: '章节',
    learn_most_common_pre: '学习最常见的',
    learn_most_common_post: '来自许多不同类别',
    or_choose_a_category: '选择一个类别：',
    chapter_end: '您已到达本章末尾！',
    phrases: '短语',
    sayings: '谚语',
    simple_texts: '文本',
    conversations: '对话',
    write: '写作',
    course: '课程'
  },
  favorites: {
    favorites: '收藏夹',
    word: '单词',
    sentence: '句子',
    sentences: '句子',
    texts: '文本',
    wordmaps: '词汇地图',
    saved: '已保存',
    title: '标题',
    type: '类型',
    word_type: '词类',
    no_favorites_found: '未找到收藏夹',
    filtered_by: '筛选条件',
    train: '训练',
    train_words: '训练 {wordCount} 个单词',
    notify_me_srs: '提醒我使用 SRS 重复词汇',
    action_sounds: '操作声音',
    srs_level: 'SRS 级别',
    success_rate: '成功率',
    translation: '翻译',
    context: '上下文',
    last_seen: '上次查看',
    next_review: '下次复习',
    short_story: '短篇小说',
    success_level_up: '单词移至级别 {level}',
    success_level_up_celebrate: '单词 {word} 移至下一个级别！',
    what_is_srs: '什么是 SRS？',
    srs_short: 'SRS 是一种间隔重复系统。它通过在正确的时间重复单词来帮助您更好地记住单词。',
    srs_long:
      '该系统基于这样的原则：您重复一个单词的次数越多，您就越能记住它。系统会确定重复之间的间隔。如果您记住一个单词很好，间隔会变长。如果您有困难，间隔会变短。这样您就可以更有效地学习单词。',
    srs_intervals: '{nIntervals} 个间隔为：{intervals} 天。',
    when_does_a_word_move: '单词何时移至下一个级别？',
    srs_next_level_example_1:
      '如果您将单词添加到收藏夹，它将处于级别 1。如果自您添加单词以来已经过了 1 天，您的成功率高于 50%，并且您刚刚正确记住了该单词，则级别 1 的单词将进入下一级别。',
    srs_next_level_example_2:
      '如果上次更改为级别 {levelM1} 至少在 {days} 天前，您的成功率高于 50%，并且您刚刚正确记住了该单词，则级别 {level} 的单词将进入下一级别。',
    favorite_group: '组',
    group_already_exists: '该名称的文件夹已存在',
    cannot_delete_default: '`默认` 文件夹无法删除',
    group_still_has_words: '该文件夹仍包含收藏夹。请先删除所有收藏夹。',
    group_deleted: '文件夹已删除'
  },
  player: {
    maximize: '最大化',
    minimize: '最小化'
  },
  video: {
    error: '加载字幕时出错。遗憾的是，并非所有字幕都可以自由访问。请尝试其他视频。',
    subtitles: '字幕'
  },
  feeds: {
    disclaimer: '这是由 Chatgpt 自动生成的摘要。原始文章可在此处获得',
    here: '这里',
    generating_article: '正在生成文章...',
    error: '加载文章时出错。遗憾的是，并非所有文章都可以自由访问。请尝试其他文章或手动复制文本',
    open_org: '1. 打开原始文章并复制文本',
    open_own: '2. 在此处粘贴文本'
  },
  books: {
    read_now: '立即阅读',
    continue_on_page: '继续阅读第'
  },
  tooltip: {
    examples: '例句',
    emotional_examples: '情感例句',
    definition: '定义',
    base_word: '原形',
    synonyms: '同义词',
    antonyms: '反义词',
    article: '冠词',
    conjugations: '变位',
    grammer: '语法',
    etymology: '词源',
    context: '语境'
  },
  custom_text: {
    enter_your_own_text: '输入您自己的文本',
    read_text: '阅读文本',
    enter_new_text: '输入新文本',
    own_text: '复制您自己的文本并在此处粘贴',
    special_vocabulary: '专业词汇'
  },
  special_vocabulary: {
    special_vocabulary: '专业词汇',
    explanation: '在这里，您可以创建一篇关于您想学习的主题的新文本。将生成一篇文本，供您学习使用。',
    describe: '用英语输入有关您想学习的主题或专业词汇的文本',
    language_level: '语言水平',
    generate_text: '生成文本'
  },
  custom_vocabulary: {
    custom_vocabulary: '自定义词汇',
    add_new_category: '添加新类别',
    title: '标题',
    description: '您想学习哪些词汇？',
    description_placeholder: '描述您想学习的词汇',
    description_example: "例如：'1到20的数字'",
    number_of_words: '词汇数量',
    generate: '生成',
    no_lists_found: '还没有自定义词汇列表',
    list_not_found: '未找到此词汇列表',
    error_generating: '生成词汇时出错,请重试。',
    home_teaser: '创建您想学习的任何主题的自定义词汇列表',
    n_lists: '个自定义列表'
  },
  live_conversations: {
    start_conversation: '开始对话',
    end_conversation: '结束对话',
    connecting: '连接中…',
    connected: '对话进行中…',
    microphone_error: '无法开始对话。请检查麦克风权限后重试。',
    not_found: '未找到该对话',
    reviewing: '正在回顾你的对话…',
    transcript_title: '你的对话',
    no_turns: '没有记录到对话。',
    no_mistakes: '没有发现错误，做得很好！',
    review_unavailable: '无法加载回顾内容，请稍后重试。'
  },
  intro_message: {
    save_word_as_fav: '将单词保存为收藏夹',
    save_video_as_fav: '将视频保存为收藏夹',
    save_article_as_fav: '将文章保存为收藏夹',
    save_book_as_fav: '将书籍保存为收藏夹',
    save_wordmap_as_fav: '将词汇地图保存为收藏夹',
    play_word: '听单词的发音',
    play_article: '听文章',
    play_book: '听书籍',
    select_main_category: '选择一个主类别',
    select_sub_category: '选择一个子类别',
    click_on_read: '点击 `阅读` 以阅读全文',
    click_on_view: '点击 `观看` 以观看视频',
    wordmap_click_on_word: '点击单词以查看最常用的单词',
    wordmap_click_on_line: '点击两个单词之间的线以查看句子',
    conversations_select_scene: '选择一个练习',
    conversations_warn: '您的句子似乎有错误。点击三角形查看更多解释。',
    conversations_task: '根据以下说明制定句子：'
  },
  tour_guide: {
    click_on_every_word: {
      title: '翻译单词',
      text: '您可以点击任何单词以查看翻译、例句和定义'
    },
    click_on_i_for_sentence: {
      title: '完整句子',
      text: '要翻译整个句子，请点击 i 符号。在这里您还可以获得有关语法的解释。'
    },
    no_save_custom: {
      title: '无法保存',
      text: '自定义文本无法保存'
    },
    change_playback_rate: {
      title: '更改播放速度',
      text: '通过菜单/设置/音频和视频更改播放速度。'
    },
    theme: {
      title: '颜色',
      text: '您可以在菜单中将颜色更改为深色模式'
    },
    repeat_words: {
      title: '重复词汇',
      text: '您应该重复 {nWords} 个词汇。',
      call_to_action: '立即学习'
    },
    flipcards: {
      title: '翻转卡',
      text: '翻转卡片并点击笑脸或哭脸以跟踪您的进度'
    },
    synapsis_score: {
      title: '突触分数',
      text: '您为每个单词赚取分数，按其级别加权，并为每个完成的章节或单元赚取额外分数'
    }
  },
  chat: {
    your_message: '您的消息',
    waiting_for_teacher: '正在等待老师...',
    in_de: '德语',
    in_en: '英语',
    in_es: '西班牙语',
    in_fr: '法语',
    in_it: '意大利语',
    in_pt: '葡萄牙语',
    in_ru: '俄语',
    in_zh: '中文',
    in_pl: '波兰语',
    wait: '请稍候...',
    speak_now: '现在说话',
    new_chat: '新聊天',
    switch_language: '切换语言',
    language_teacher: '语言老师',
    summarize_mistakes: '总结错误'
  },
  langs: {
    de: '德语',
    en: '英语',
    sp: '西班牙语',
    fr: '法语',
    it: '意大利语',
    pt: '葡萄牙语',
    pl: '波兰语',
    ru: '俄语',
    zh: '中文'
  },
  countries: {
    de: '德国',
    en: '英国',
    es: '西班牙',
    fr: '法国',
    it: '意大利',
    pt: '葡萄牙',
    pl: '波兰',
    ru: '俄罗斯',
    zh: '中国'
  },
  about: {
    how_does_it_work: '它是如何工作的？',
    here_you_can: '在这里您可以',
    read_texts: '阅读文本',
    watch_videos: '观看视频',
    click_on_every_wrord_for: '点击任何单词以获得',
    translations: '翻译',
    examples: '例句',
    definitions: '定义',
    synonyms: '同义词',
    copy_your_own_text: '复制并阅读您自己的文本',
    chat_with_chatbot: '与聊天机器人聊天',
    level: '您的水平应在 B1 和 C2 之间'
  },
  settings: {
    audio_video: '音频和视频',
    level: '级别',
    colors: '颜色',
    dark_mode: '深色模式',
    lang_level: '语言水平',
    show_pinyin: '显示拼音',
    show_translation: '显示翻译'
  },
  error: {
    resource_not_found: '抱歉，我们找不到您要查找的内容'
  },
  train: {
    check: '检查',
    flashcards: '抽认卡',
    exercises: '练习',
    finished: '练习已完成',
    go_to_favorites: '转到收藏夹',
    restart_exercise: '重新开始练习',
    go_to_home: '转到主页',
    text_with_words: '带有单词的文本',
    text_includes: '文本包含您想学习的所有单词',
    generate_audio: '生成音频',
    stop_audio: '停止音频'
  },
  wordmap: {
    click_on_circle: '点击圆圈以查看与 {word} 最常用的单词',
    click_on_edge: '点击两个单词之间的线以查看包含两个单词的句子',
    open_fullscreen: '以全屏模式打开词汇地图',
    add_own_word: '添加自己的单词',
    add_sentence_with_all_words: '添加包含所有单词的句子',
    add_to_word: '添加到单词'
  },
  conversations: {
    you_are: '您是',
    you_talk_to: '您与谁交谈',
    your_tasks: '您的任务'
  },
  write: {
    min_words: '最少单词数',
    your_email_needs_to_contain: '您的电子邮件需要包含',
    rate: '评分',
    analysis: '分析',
    overall: '总体',
    grammar: '语法',
    content: '内容',
    spelling: '拼写',
    passed: '做得好！您通过了这个练习。',
    failed: '继续练习！您的分数不足以通过。',
    restart: '再试一次'
  },
  cookies: {
    title: '本网站使用 Cookie',
    description:
      '我们使用 Cookie 来个性化内容和广告，提供社交媒体功能并分析我们的流量。我们还与社交媒体、广告和分析合作伙伴分享有关您使用我们网站的信息，他们可能会将这些信息与您提供给他们或他们从您使用其服务中收集的其他信息相结合。',
    description_short: '我们使用 Cookie 来个性化内容和广告，提供社交媒体功能并分析我们的流量...',
    deny: '拒绝',
    allow_selection: '允许选择',
    clear_local_storage: '清除本地存储键',
    clear_local_storage_confirm: '您确定要删除选定的本地存储键吗？',
    clear_local_storage_success: '选定的本地存储键已被删除。',
    tooltip_necessary:
      '必要的 Cookie 通过启用页面导航和访问网站安全区域等基本功能来帮助网站可用。没有这些 Cookie，网站无法正常运行。',
    tooltip_preferences:
      '首选项 Cookie 使网站能够记住改变网站行为或外观的信息，例如您的首选语言或您所在的地区。',
    tooltip_statistics:
      '统计 Cookie 通过匿名收集和报告信息来帮助网站所有者了解访问者如何与网站互动。',
    tooltip_marketing:
      '营销 Cookie 用于跟踪跨网站的访问者。目的是显示与个人用户相关且有吸引力的广告，从而对发布商和第三方广告商更有价值。'
  },
  grammar: {
    menu_title: '语法',
    start_grammar_lessons: '开始语法课程',
    loading: '正在加载语法菜单...',
    error_loading: '加载语法菜单失败',
    retry: '重试',
    no_content: '没有可用的语法内容',
    chapter: '章节',
    loading_lesson: '正在加载课程...',
    error_loading_lesson: '加载课程失败',
    overview: '概览',
    detailed_explanation: '详细解释',
    core_rules: '核心规则',
    examples: '示例',
    common_mistakes: '常见错误',
    exceptions: '例外',
    variations: '变体',
    practice_exercises: '练习题',
    question: '问题',
    check_answer: '检查答案',
    correct_answer_feedback: '正确！做得好。',
    incorrect_answer_feedback: '不正确。正确答案是：',
    rule: '规则',
    exercise: '练习',
    results: '结果',
    passed: '做得好！您通过了！',
    failed: '继续练习！您没有通过。'
  },
  transcription: {
    title: '实时转录',
    subtitle: '聆听对话内容，并实时显示为屏幕上的文字',
    start: '开始转录',
    stop: '停止',
    listening: '正在聆听…',
    transcribing: '转录中…',
    mic_settings_title: '麦克风设置',
    mic_mode_close: '近距离语音',
    mic_mode_distant: '远距离/播放音频',
    mic_boost_label: '麦克风增益',
    mic_settings_hint: '将在下次开始时生效',
    mic_level_label: '麦克风输入音量',
    mic_level_clipping: '声音过大',
    mic_test_start: '测试麦克风',
    mic_test_stop: '停止测试',
    empty_state: '点击"开始转录"并开始说话，内容将显示在这里',
    not_supported: '此浏览器不支持实时转录。请确保麦克风权限可用。',
    microphone_error: '无法访问麦克风。请检查麦克风权限后重试。',
    transcription_error: '无法转录该片段，继续聆听中…',
    copied: '转录内容已复制到剪贴板'
  },
  video_object_detection: {
    title: '视频物体识别',
    subtitle: '将摄像头对准周围的物体，用你正在学习的语言查看它们的名称',
    start: '开始视频',
    stop: '停止',
    scanning: '扫描中…',
    empty_state: '点击"开始视频"并将摄像头对准物体，即可在此处看到标注',
    not_supported: '此浏览器不支持摄像头访问。请尝试使用 Chrome 或 Edge。',
    camera_error: '无法访问摄像头。请检查摄像头权限后重试。',
    detected_words: '检测到的词语',
    nearby_objects: '附近的其他物体——点击添加'
  }
};
